import i18n from 'scoreboard/components/i18n'
import _ from 'lodash'
import enums from 'scoreboard/components/enums'
import { getLabel } from './if-operator-options'

/**
 * @returns a list of options for the transformation-then operator select
 * options are placed in a specific order and grouped (#29852).
 * Some labels may be different from the message code in their enum (ex. have an
 * ellipsis added at the end of the label)
 */
function thenOperatorOptions(type) {
	let text = i18n.get('admin.import.transform.header.text')
	let dates = i18n.get('admin.import.transform.header.dates')
	let cleanup = i18n.get('admin.import.transform.header.cleanup')

	let thenOperators = enums.thenOperator
	let options = [
		{
			id: 'make-x',
			label: getLabel(thenOperators['make-x'], true),
			group: 'headerless'
		},
		{
			id: 'make-blank',
			label: getLabel(thenOperators['make-blank']),
			group: 'headerless'
		}, // datasets only
		{
			id: 'import-blank-value',
			label: getLabel(thenOperators['import-blank-value']),
			group: 'headerless'
		}, // mvi only
		{
			id: 'do-not-import-value',
			label: getLabel(thenOperators['do-not-import-value']),
			group: 'headerless'
		}, // mvi only
		{
			id: 'prepend',
			label: getLabel(thenOperators['prepend'], true),
			group: text
		},
		{
			id: 'append',
			label: getLabel(thenOperators['append'], true),
			group: text
		},
		{
			id: 'replace',
			label: getLabel(thenOperators['replace'], true),
			group: text},
		{
			id: 'remove-first-characters',
			label: getLabel(thenOperators['remove-first-characters'], true),
			group: text
		},
		{
			id: 'remove-last-characters',
			label: getLabel(thenOperators['remove-last-characters'], true),
			group: text
		},
		{
			id: 'use-first-characters',
			label: getLabel(thenOperators['use-first-characters'], true),
			group: text
		},
		{
			id: 'use-last-characters',
			label: getLabel(thenOperators['use-last-characters'], true),
			group: text
		},
		{
			id: 'convert-to-date',
			label: getLabel(thenOperators['convert-to-date'], true),
			group: dates
		},
		{
			id: 'remove-types-of-characters',
			label: getLabel(thenOperators['remove-types-of-characters'], true),
			group: cleanup
		}
	]

	// do not display operators that don't apply to type
	if (type != 'dataset') {
		options = _.filter(options, o => o.id != 'make-blank')
	}

	if (type != 'metric-value') {
		options = _.filter(options, o => {
			if (o.id === 'do-not-import-value' ||
				o.id === 'import-blank-value') {
				return false
			} else {
				return true
			}
		})
	}

	return options
}

export default thenOperatorOptions
thenOperatorOptions.__filename__ = 'imports/transform/then-operator-options.js'
